import { _404_MY_BAZAAR_LAST_PRODUCT_NOT_FOUND } from 'mk/autogenerated/translations/MyBazaarLastProductNotFoundPage.49e50f8fb677b021c86ccbc1f58c19f7'
import {
    MyBazaarLastProductNotFound,
} from 'mk2/apps/bazaar/containers/MyBazaarLastProductNotFound/MyBazaarLastProductNotFound';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page from 'mk2/pages/Page';
import { AppState } from 'mk2/reducers';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {}
interface StateProps {}
interface DispatchProps {}
type RouteProps = RouteComponentProps<{}>;

type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class MyBazaarLastProductNotFoundPage extends Page<OwnProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => ({});
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {};
    }

    public getMetaTitle(props: Props): string {
        return _404_MY_BAZAAR_LAST_PRODUCT_NOT_FOUND;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <MyBazaarLastProductNotFound {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public registerInStore(store: Store<AppState>) {
        // nothing to do
    }
}
